import { c as _c } from "react/compiler-runtime";
import AllowlistToolLoader, { AllowlistToolLoaderSize } from "@/components/allowlist-tool/common/AllowlistToolLoader";
export default function DistributionPlanToolPlansLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-text-center"><AllowlistToolLoader size={AllowlistToolLoaderSize.LARGE} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}